import { useState, useCallback } from "react";
import * as XLSX from "xlsx";
import toast from "react-hot-toast";
import useAxios from "services/useAxios.tsx";

export default function UploadExcel() {
  const { execute: addBrandApi } = useAxios("api/Insert_Brand");
  const { execute: addProductApi } = useAxios("product/add_product_excel");
  const [excel, setExcel] = useState();
  const [excelUnification, setExcelUnification] = useState();
  const onChangeExcelUnification = (e) => {
    const file = e.target.files[0];

    if (file) {
      if (!file.name.endsWith(".xlsx") && !file.name.endsWith(".xls")) {
        e.target.value = null;
        setExcelUnification(undefined);
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        setExcelUnification(workbook);
      };

      reader.readAsBinaryString(file);
    }
  };
  const onSubmitFunc = useCallback(async () => {
    if (excelUnification == undefined)
      return toast.error("خطا! اکسل اجباری می باشد!");
    // const firstSheetTest = XLSX.utils.sheet_to_json(
    //   excelUnification.Sheets[excelUnification.SheetNames[0]],
    //   { header: 1 }
    // );
    // const secondSheetRatio = XLSX.utils.sheet_to_json(
    //   excelUnification.Sheets[excelUnification.SheetNames[1]],
    //   { header: 1 }
    // );
    // const thirdSheetQuestions = XLSX.utils.sheet_to_json(
    //   excelUnification.Sheets[excelUnification.SheetNames[2]],
    //   { header: 1 }
    // );
    const fourthSheetQuestions = XLSX.utils.sheet_to_json(
      excelUnification.Sheets[excelUnification.SheetNames[3]],
      { header: 1 }
    );
    const fifthSheetQuestions = XLSX.utils.sheet_to_json(
      excelUnification.Sheets[excelUnification.SheetNames[4]],
      { header: 1 }
    );
    // let testData = firstSheetTest
    //   .splice(1, firstSheetTest.length)
    //   .map((item) => {
    //     let faComma = item[5]?.toString()?.search("،");
    //     let enComma = item[5]?.toString()?.search(",");
    //     return {
    //       title: item[0],
    //       description: item[1],
    //       time: item[2],
    //       pass_grade: item[3],
    //       category:
    //         faComma != -1 || enComma != -1
    //           ? enComma != -1
    //             ? item[5]?.split(",")
    //             : item[5]?.split("،")
    //           : [item[5]],
    //       id: 0,
    //     };
    //   });
    // let ratioData = secondSheetRatio
    //   .splice(1, secondSheetRatio.length)
    //   .map((item) => ({
    //     hashtag_id: item[0],
    //     ratio: item[1],
    //     negative_point: item[2],
    //     parent_id: testData?.[0]?.id,
    //   }));
    // let questionData = thirdSheetQuestions
    //   .splice(1, thirdSheetQuestions.length)
    //   .map((item) => ({
    //     question: item[0],
    //     first_option: item[1],
    //     second_option: item[2],
    //     third_option: item[3],
    //     fourth_option: item[4],
    //     correct_answer: item[5],
    //     hashtag_id: item[6],
    //     sort: item[7],
    //     test_id: testData?.[0]?.id,
    //   }));
    let productData = fifthSheetQuestions?.map((value) => ({
      title: value?.[5],
      brandid: value?.[6],
      main_tag: value?.[2],
      sub_tag: value?.[3],
    }));
    // let brandData = fourthSheetQuestions?.map((value) => ({
    //   name: value?.[1],
    // }));

    try {
      for (const item of productData) {
        console.log("fifthSheetQuestions", item);
        addProductApi(item);
        // const res = await addBrandApi(item);
      }
      //   for (const item of testData) {
      //     const res = await addTestApi({
      //       title: item.title,
      //       description: item.description || "",
      //       time: item.time || "",
      //       pass_grade: item.pass_grade || "",
      //       test_question_count: questionData?.length || "",
      //       mtm: Math.floor(new Date().getTime() / 1000),
      //     });
      //     if (res.status) item.id = res.result.id;
      //     for (const tag of item?.category) {
      //       await addHashtagLink({
      //         hashtags_id: tag,
      //         parent_id: item?.id,
      //       });
      //     }

      //     for (const ratio of ratioData) {
      //       await addHashtagLink({
      //         hashtags_id: ratio?.hashtag_id,
      //         parent_id: item?.id,
      //         ratio: ratio?.ratio,
      //         negative_point: ratio?.negative_point,
      //       });
      //     }
      //     for (const ques of questionData) {
      //       await addQuestion({
      //         ...ques,
      //         mtm: Math.floor(new Date().getTime() / 1000),
      //         test_id: item?.id,
      //       });
      //     }
      //   }
      toast.success("عملیات با موفقیت انجام شد!");
      setExcelUnification(undefined);
    } catch (err) {
      console.log("error: ", err);
    }
  }, [excelUnification]);
  return (
    <div className="my-5 mx-auto w-75">
      <input
        type="file"
        className="form-control"
        onChange={onChangeExcelUnification}
      />
      <button
        className="btn bg-success text-light m-2"
        style={{ height: "8vh", width: 150 }}
        onClick={onSubmitFunc}
      >
        بارگذاری اکسل
      </button>
    </div>
  );
}
